import React, { PropsWithChildren, useMemo } from 'react';
import { StatusTagEnum } from '@tryhackme/thm-ui-components';
import useMeasure from 'react-use-measure';
import InfoSvg from 'src/images/svgs/info.svg';
import { ToolTip } from 'src/common/components';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { StyledMachineWrapper, StyledMachineDetails, StyledTitle, StyledTag, StyledTagTitle, StyledTagWrapper, StyledImage } from './virtual-environment-machine.styles';
type VirtualEnvironmentMachineProps = {
  title: string;
  tooltipText: string;
  tagStatus: StatusTagEnum;
  tagTitle: string;
};
export const VirtualEnvironmentMachine: React.FC<PropsWithChildren<VirtualEnvironmentMachineProps>> = ({
  title,
  tooltipText,
  children,
  tagTitle,
  tagStatus
}) => {
  const [ref, {
    width
  }] = useMeasure();
  const isWide = useMemo(() => width > BREAKPOINTS.MOBILE, [width]);
  return <StyledMachineWrapper ref={ref} data-sentry-element="StyledMachineWrapper" data-sentry-component="VirtualEnvironmentMachine" data-sentry-source-file="virtual-environment-machine.tsx">
      <StyledMachineDetails data-sentry-element="StyledMachineDetails" data-sentry-source-file="virtual-environment-machine.tsx">
        <span>
          <StyledTitle $isWide={isWide} data-sentry-element="StyledTitle" data-sentry-source-file="virtual-environment-machine.tsx">{title}</StyledTitle>
          <ToolTip toolTipText={tooltipText} $contentMaxWidth="33rem" side="right" $fontSize="tiny" data-sentry-element="ToolTip" data-sentry-source-file="virtual-environment-machine.tsx">
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
            <StyledImage src={InfoSvg} onClick={e => e.stopPropagation()} alt="Machine info" data-sentry-element="StyledImage" data-sentry-source-file="virtual-environment-machine.tsx" />
          </ToolTip>
        </span>
        <StyledTagWrapper data-sentry-element="StyledTagWrapper" data-sentry-source-file="virtual-environment-machine.tsx">
          Status:
          <StyledTag status={tagStatus} size="default" data-sentry-element="StyledTag" data-sentry-source-file="virtual-environment-machine.tsx">
            <StyledTagTitle data-sentry-element="StyledTagTitle" data-sentry-source-file="virtual-environment-machine.tsx">{tagTitle}</StyledTagTitle>
          </StyledTag>
        </StyledTagWrapper>
      </StyledMachineDetails>
      {children}
    </StyledMachineWrapper>;
};